import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Alert, Button, Card, Form, Input, Layout, Typography } from "antd";

import { ApiError, api } from "../api/client";

const { Title, Paragraph } = Typography;

interface SetupFormValues {
  username: string;
  password: string;
  email?: string;
  real_name?: string;
}

export const SetupPage = () => {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const onFinish = async (values: SetupFormValues) => {
    setError(null);
    setSubmitting(true);
    try {
      await api.createFirstOwner(values);
      navigate("/dashboard");
    } catch (err) {
      setError(err instanceof ApiError ? err.message : String(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Layout
      style={{
        minHeight: "100dvh",
        alignItems: "center",
        justifyContent: "center",
        background: "var(--ant-color-bg-layout)",
        padding: 24,
      }}
    >
      <Card style={{ width: 480 }}>
        <Title level={3} style={{ marginBottom: 0 }}>
          Create the first Owner
        </Title>
        <Paragraph type="secondary">
          You are signed in as the superadmin. Create the first regular Owner account; after
          that, this setup page becomes unreachable.
        </Paragraph>
        {error && <Alert type="error" message={error} style={{ marginBottom: 16 }} showIcon />}
        <Form<SetupFormValues> layout="vertical" onFinish={onFinish} disabled={submitting}>
          <Form.Item
            label="Username"
            name="username"
            rules={[{ required: true, message: "Username is required" }]}
          >
            <Input autoComplete="off" autoFocus />
          </Form.Item>
          <Form.Item
            label="Password"
            name="password"
            rules={[
              { required: true, message: "Password is required" },
              { min: 12, message: "At least 12 characters" },
            ]}
          >
            <Input.Password autoComplete="new-password" />
          </Form.Item>
          <Form.Item label="Email (optional)" name="email">
            <Input type="email" autoComplete="email" />
          </Form.Item>
          <Form.Item label="Real name (optional)" name="real_name">
            <Input autoComplete="name" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" block loading={submitting}>
              Create Owner
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </Layout>
  );
};
